/** Flatten featured + category products from GET /marketplace/quote-extras */
export function quoteExtrasProductMap(catalog) {
  const map = new Map();
  (catalog?.featured || []).forEach((p) => {
    if (p?.productId) map.set(p.productId, p);
  });
  (catalog?.categories || []).forEach((cat) => {
    (cat?.products || []).forEach((p) => {
      if (p?.productId) map.set(p.productId, p);
    });
  });
  return map;
}

function unitPriceCents(product) {
  const sale =
    product?.salePrice != null && product.salePrice > 0
      ? Number(product.salePrice)
      : null;
  const base = Number(product?.price || 0);
  const zar = sale != null ? sale : base;
  return Math.round(zar * 100);
}

function productVatOptions(product) {
  const meta = product?.meta || {};
  const vatRate =
    meta.vatRate != null && !Number.isNaN(Number(meta.vatRate))
      ? Number(meta.vatRate)
      : 0.15;
  const vatInclusive = meta.vatInclusive === false ? false : true;
  return { vatInclusive, vatRate };
}

/** Mirror server splitLineVatCents for in-sheet price preview. */
function splitLineVatCents(amountCents, { vatInclusive = true, vatRate = 0.15 } = {}) {
  const amount = Math.max(0, Math.round(amountCents || 0));
  if (amount <= 0 || vatRate <= 0) {
    return { subtotalCents: amount, vatCents: 0, totalCents: amount };
  }
  if (vatInclusive) {
    const subtotalCents = Math.round(amount / (1 + vatRate));
    const vatCents = amount - subtotalCents;
    return { subtotalCents, vatCents, totalCents: amount };
  }
  const subtotalCents = amount;
  const vatCents = Math.round(subtotalCents * vatRate);
  return { subtotalCents, vatCents, totalCents: subtotalCents + vatCents };
}

/** Client-side estimate while /quote is in flight (prices are ZAR on catalog). */
export function estimateExtrasFromCart(catalog, cart) {
  const byId = quoteExtrasProductMap(catalog);
  const lines = [];
  let totalCents = 0;
  let subtotalCents = 0;
  let vatCents = 0;

  Object.entries(cart || {}).forEach(([productId, qtyRaw]) => {
    const qty = parseInt(qtyRaw, 10) || 0;
    if (qty <= 0) return;
    const product = byId.get(productId);
    if (!product) return;
    const unitCents = unitPriceCents(product);
    const { vatInclusive, vatRate } = productVatOptions(product);
    const unitSplit = splitLineVatCents(unitCents, { vatInclusive, vatRate });
    const lineSubtotalCents = unitSplit.subtotalCents * qty;
    const lineVatCents = unitSplit.vatCents * qty;
    const lineTotalCents = unitSplit.totalCents * qty;
    subtotalCents += lineSubtotalCents;
    vatCents += lineVatCents;
    totalCents += lineTotalCents;
    lines.push({
      productId,
      name: product.name,
      qty,
      unitPriceCents: unitCents,
      lineSubtotalCents,
      lineVatCents,
      lineTotalCents,
    });
  });

  lines.sort((a, b) => a.name.localeCompare(b.name));
  return { lines, totalCents, subtotalCents, vatCents };
}

export function extrasCartSignature(cart) {
  return Object.entries(cart || {})
    .filter(([, qty]) => (parseInt(qty, 10) || 0) > 0)
    .map(([id, qty]) => `${id}:${parseInt(qty, 10)}`)
    .sort()
    .join("|");
}

export function extrasLinesSignature(lines) {
  return (lines || [])
    .map((l) => `${l.productId}:${l.qty}`)
    .sort()
    .join("|");
}
